module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/microsoft-28906fd427834196be9d2a7a6a761dc0.png";